<template>
<panel>
  <p slot="header">
    Dodaj konto do wysyłania
  </p>
  <p slot="actions">
    <ui-button type="flat" icon="navigate_before" color="primary" @click="$router.push({name: 'admin.accounts.dashboard'})">Wróć do kont</ui-button>
  </p>
  <accounts-form :item="item"></accounts-form>
</panel>

</template>
<script>
  import Accounts from './../../services/Accounts'

  export default {
    data () {
      return {
        item: Accounts.getBaseItem()
      }
    },
    mounted () {
    }
  }

</script>


// WEBPACK FOOTER //
// Create.vue?64091b05